"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const uuid_1 = require("uuid");
const Slider = ({ onChange, color, activeColor, checked, onClick }) => {
    const id = uuid_1.v4();
    return (react_1.default.createElement(CheckBoxWrapper, { onClick: onClick },
        react_1.default.createElement(CheckBox, { id: id, type: "checkbox", onChange: onChange, color: activeColor, checked: checked }),
        react_1.default.createElement(CheckBoxLabel, { htmlFor: id, color: color })));
};
exports.default = Slider;
const CheckBoxWrapper = styled_components_1.default.div `
  position: relative;
  display: inline-block;
`;
const CheckBoxLabel = styled_components_1.default.label `
  position: absolute;
  top: 0;
  left: 0;
  width: 2.6rem;
  height: 1.4rem;
  border-radius: 0.8rem;
  background: ${props => props.color || "#bebebe"};
  cursor: pointer;
  &::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 1rem;
    height: 1rem;
    margin: 0.2rem;
    background: #ffffff;
    box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
    transition: 0.2s;
  }
`;
const CheckBox = styled_components_1.default.input `
  opacity: 0;
  z-index: 1;
  width: 2.6rem;
  height: 1.4rem;
  border-radius: 0.8rem;
  &:checked + ${CheckBoxLabel} {
    background: ${props => props.color || "#4fbe79"};
    &::after {
      content: "";
      display: block;
      border-radius: 50%;
      width: 1rem;
      height: 1rem;
      margin: 0.2rem;
      margin-left: 1.4rem;
      transition: 0.2s;
    }
  }
`;
